module.exports = __webpack_public_path__ + "img/electric.5e10c107.jpeg";